import React from 'react';
import { HiOutlinePencilAlt } from 'react-icons/hi';
import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';

const ClientRow = ({ id, name, tradeName, className }) => {

    const navigate = useNavigate();

    const handleClickRow = () => {
        navigate('/client/detail/' + id);
    };

    return (
        <>
            {
                name ?
                <tr className={className} style={{cursor: "default"}}>
                    <td>{name}</td>
                    <td>{tradeName}</td>
                    <td className='text-center'>
                        <a className='td-icon mx-1' style={{cursor: "pointer"}} onClick={handleClickRow} title={intl.get('roleRow.editButton.title')}>
                            <HiOutlinePencilAlt/>
                        </a>
                    </td>
                </tr> :
                null
            }
        </>
    )
}

export default ClientRow;
